import { Directive, OnInit, Input, ElementRef, Output, EventEmitter, Renderer2 } from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[gridStack]'
})
export class GridStackDirective implements OnInit {

    @Input() w: number;
    @Input() animate: boolean;
    @Input() options: any = {
        cellHeight: 80,
        verticalMargin: 10
    };
    @Output() gridInited = new EventEmitter<any>();
    constructor(
        private el: ElementRef,
        private renderer: Renderer2
    ) {

        renderer.setAttribute(el.nativeElement, 'class', 'grid-stack');
    }

    ngOnInit(): void {

        const self = this;

        let renderer = this.renderer;
        let nativeElement = this.el.nativeElement;
        let animate: string = this.animate ? 'yes' : 'no';

        renderer.setAttribute(nativeElement, 'data-gs-width', String(this.w));
        if (animate === 'yes') {
            renderer.setAttribute(nativeElement, 'data-gs-animate', animate);
        }

        // tslint:disable-next-line: variable-name
        let _default = {
            cellHeight: 80,
            verticalMargin: 10
        };

        let opt = Object.assign(_default, this.options);

        // TODO: listen to an event here instead of just waiting for the time to expire 
        setTimeout(function () {
            
            let $grid = $('.grid-stack').gridstack(opt);
            self.gridInited.emit($grid);
        }, 10);
    }

}
